import React, { useState, useEffect } from 'react';
import MyLogo from '../../../image/MyLogo.png';
import LoginBoxWrapper from './LoginBox.styled';

function FindIdView({ onSwitchTab }) {
  const [sendData, setSendData] = useState({ UserName: '', UserEmail: '' });
  const [foundId, setFoundId] = useState(null);

  const findId = async () => {
    try {
      const res = await fetch('/request/MemberFindId', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sendData)
      });
      const data = await res.json();
      if (data && data.length > 0) {
        setFoundId(data[0].user_id);
      } else {
        alert('일치하는 계정을 찾을 수 없습니다.');
      }
    } catch (err) {
      alert('아이디 찾기 오류: ' + err);
    }
  };

  return (
    <div className='TabPageBig'>
      <nav className="SubNavLeft">
        <ul>
          <li><button type="button" className="TabActive" onClick={() => onSwitchTab('id')}>아이디 찾기</button></li>
          <li><button type="button" onClick={() => onSwitchTab('pw')}>비밀번호 찾기</button></li>
        </ul>
      </nav>
      <div className="find-member-layout">
        <div className="find-member-logo">
          <img src={MyLogo} alt="앤츠네스트 로고" />
        </div>
        <div className="find-member-form">
          <div className="find-member-field">
            <input type='email' placeholder='이메일 주소'
              onChange={(ev) => setSendData({ ...sendData, UserEmail: ev.target.value })} />
          </div>
          <div className="find-member-field">
            <input type='text' placeholder='이름'
              onChange={(ev) => setSendData({ ...sendData, UserName: ev.target.value })} />
          </div>
          <div className="find-member-field">
            <button className='LoginButton' type="button" onClick={findId}>아이디 찾기</button>
          </div>
          {foundId && (
            <div className="find-member-result">
              아이디 : <strong>{foundId}</strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ChangePasswordForm() {
  const [resetData, setResetData] = useState({ UserPw: '', UserPwCheck: '', CertKey: '', UserId: '' });
  const [certKey, setCertKey] = useState('');

  // certKey is set by parent via props — but since this is shown after certification,
  // we pass it through a closure. We'll use a ref pattern instead.
  const changePassword = async () => {
    if (resetData.UserPw !== resetData.UserPwCheck) {
      alert('비밀번호가 일치하지 않습니다.');
      return;
    }
    try {
      await fetch('/request/MemberPwUpdate', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(resetData)
      });
      alert('비밀번호가 변경되었습니다.');
    } catch (err) {
      alert('비밀번호 변경 실패: ' + err);
    }
  };

  return (
    <div className="find-member-change-pw">
      <div className="find-member-field">
        <input type='password' placeholder='인증번호'
          onChange={(ev) => setResetData({ ...resetData, CertKey: ev.target.value })} />
      </div>
      <div className="find-member-field">
        <input type='text' placeholder='아이디'
          onChange={(ev) => setResetData({ ...resetData, UserId: ev.target.value })} />
      </div>
      <div className="find-member-field">
        <input type='password' placeholder='변경할 비밀번호'
          onChange={(ev) => setResetData({ ...resetData, UserPw: ev.target.value })} />
      </div>
      <div className="find-member-field">
        <input type='password' placeholder='비밀번호 확인'
          onChange={(ev) => setResetData({ ...resetData, UserPwCheck: ev.target.value })} />
      </div>
      <div className="find-member-field">
        <button className='LoginButton' type="button" onClick={changePassword}>비밀번호 변경</button>
      </div>
    </div>
  );
}

function FindPwView({ onSwitchTab }) {
  const [sendData, setSendData] = useState({ UserId: '', UserEmail: '' });
  const [showChangeForm, setShowChangeForm] = useState(false);
  const [certificationKey, setCertificationKey] = useState('');

  const sendCertification = async () => {
    try {
      const res = await fetch('/request/MemberFindPw', {
        method: 'POST', mode: 'cors', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sendData)
      });
      const data = await res.json();
      setCertificationKey(data.Key);
      setShowChangeForm(true);
    } catch (err) {
      alert('인증번호 전송 실패: ' + err);
    }
  };

  return (
    <div className='TabPageBig'>
      <nav className="SubNavLeft">
        <ul>
          <li><button type="button" onClick={() => onSwitchTab('id')}>아이디 찾기</button></li>
          <li><button type="button" className="TabActive" onClick={() => onSwitchTab('pw')}>비밀번호 찾기</button></li>
        </ul>
      </nav>
      <div className="find-member-layout">
        <div className="find-member-logo">
          <img src={MyLogo} alt="앤츠네스트 로고" />
        </div>
        <div className="find-member-form">
          <div className="find-member-field">
            <input type='email' placeholder='이메일 주소'
              onChange={(ev) => setSendData({ ...sendData, UserEmail: ev.target.value })} />
          </div>
          <div className="find-member-field">
            <button className='LoginButton' type="button" onClick={sendCertification}>비밀번호 찾기</button>
          </div>
          {showChangeForm && <ChangePasswordForm certKey={certificationKey} />}
        </div>
      </div>
    </div>
  );
}

function FindMemberInfo() {
  const [activeTab, setActiveTab] = useState('id');

  return (
    <LoginBoxWrapper>
      <div className="find-member-container">
        {activeTab === 'id'
          ? <FindIdView onSwitchTab={setActiveTab} />
          : <FindPwView onSwitchTab={setActiveTab} />
        }
      </div>
    </LoginBoxWrapper>
  );
}

export default FindMemberInfo;
